export default __webpack_public_path__ + "static/afiU-logo-horizontal-white-fr-6a258ddf388262986384aa7b2c0fac23.svg";